import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import InfoBlockMiami from './InfoBlockMiami'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import timelineIcon from '../../../../public/img/miami/ui/icon-timelineBullet.svg'
import StoryMiami from './StoryMiami';
import BackButtonMiami from './BackButtonMiami';
import miamiConstants from './MiamiConstants';
import { dp } from '../../../utils/shared.js';

var spacialEvents;
const config = {
	events_on_screen: 10,
	line_thickness: 0.02,
}

class Timeline extends Component {

	constructor(props) {
		super(props);
		this.refDict = {};
		this.cycleDate = this.cycleDate.bind(this);
		this.onScrollEnd = this.onScrollEnd.bind(this);
		this.state = {
			spacialEvents: null,
			sideMargin: null,
			totalHeight: null,
			currentEvent: 0,
			showStoryModal: false,
			initializedRefs: false,
			contentIndex: 0
		}
		this._subscribeModule = null;
		this._buttonBinded = false;
		this.getSubscribeModule();
		this._baseInset = this.props.screen.screenWidth * .5;
		this._eventIndex = 0;
		this._rowWrapperRef = null;
		this._titleStyle = {
			position: 'absolute',
			fontFamily: 'aleo-bolditalic', fontSize: this.props.screen.r16_9.p10,
			left: this.props.screen.r16_9.width * .05,
		}
		this._titleHorizontalRule = {
			width: '90%',
			height: this.props.screen.r16_9.p10 * 0.15,
			backgroundColor: '#223954',
			display: 'inline-block',
			position: 'absolute',
			top: this.props.screen.r16_9.p10 * 1.25,
			left: 0,
			marginLeft: this.props.screen.r16_9.width * .05,
		}
		this._bottomNavOffset = 0;
		if (this.props.content.settings.custom_vars && this.props.content.settings.custom_vars.bottomnav === "true") {
			this._bottomNavOffset = this.props.screen.r16_9.p10;
		}
		this.timelineRefs = [];
	}

	componentWillUnmount() {
		for (let a = 0; a < this.timelineRefs.length; a++) {
			if (this.timelineRefs[a].el) {
				this.timelineRefs[a].el.removeEventListener("tap", () => this.handleEventSelection(this.timelineRefs[a].data));
			}
		}
	}

	componentDidMount() {
		let totalHeight = (this.props.module.contents.events.length + 1) * (this.props.screen.sv.height / config.events_on_screen); // + this.props.screen.sv.height * 2;
		this.getRelativeLocations(this.props.module.contents.events, totalHeight, 0);

		// if (this._rowWrapperRef) {
		// 	this._rowWrapperRef.addEventListener("tap", () => this.redirect());
		// }
	}

	initializeTimelineRefs = () => {
		if (this.state.initializedRefs === false) {
			for (let a = 0; a < this.timelineRefs.length; a++) {
				this.timelineRefs[a].el.addEventListener("tap", () => this.handleEventSelection(this.timelineRefs[a].data));
			}
			this.setState({
				initializedRefs: true
			})
		}
	}

	handleBack = () => {
		this.setState({
			showStoryModal: false
		})
	}

	getRelativeLocations(events, totalHeight, topMargin) {

		//console.log("relative locations", events);
		//console.log("totalHieght", totalHeight)
		spacialEvents = [];

		if (this.props.module.contents.event_spacing === "even") {
			let eventInc = this.props.screen.sv.height / config.events_on_screen;
			//console.log("eventInc", eventInc);
			_.forEach(events, (event, index) => {
				let raw = eventInc * index;
				let span = raw + eventInc;
				spacialEvents.push({ header: event.header, date: this.parseDate(new Date(event.date * 1000)), offset: span, raw: raw, text: event.text, images: event.images, story: event.story })
			});
			this.setState({
				spacialEvents: spacialEvents,
				// sideMargin: topMargin,
				totalHeight: totalHeight
			})
		}
		else { //relative spacing
			let fullTimeSpan = events[events.length - 1].date - events[0].date;
			_.forEach(events, (event) => {
				let raw = (((event.date - events[0].date) / fullTimeSpan) * totalHeight)
				let span = raw + topMargin;
				spacialEvents.push({ header: event.header, date: this.parseDate(new Date(event.date * 1000)), offset: span, raw: raw, text: event.text, images: event.images, story: event.story })
			});
			this.setState({
				spacialEvents: spacialEvents,
				//     sideMargin: topMargin,
				totalHeight: totalHeight
			})
		}
	}

	parseDate = (date) => {

		let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
			"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
		];
		let monthName = monthNames[date.getMonth()]
		// let monthNumber = String(date.getMonth() + 1);
		let fullYear = String(date.getFullYear());
		// let shortYear = fullYear.substring(2);
		let day = String(date.getDate());
		let unit = this.props.screen.r9_16.p10
		return <span>
			<b>
				<span style={{ fontSize: unit * .2 }}>{monthName} {day}</span>
				<br />
				<span style={{ fontSize: unit * .35 }}>{fullYear}</span>
			</b>
		</span>


	}

	onScrollEnd(e) {
		// let yVal = Math.abs(e.y);
		// let tempCurrentEvent = 0;
		// let closestDist = null; //always pinning first to zero

		// for (var i = 0; i < spacialEvents.length; i++) {
		//     let dist = Math.abs(spacialEvents[i].raw - yVal);
		//     if (closestDist === null) {
		//         tempCurrentEvent = i;
		//         closestDist = dist;
		//     }
		//     else {
		//         if (dist < closestDist) {
		//             tempCurrentEvent = i;
		//             closestDist = dist;
		//         }
		//     }
		// }

		// this.refDict[0].withIScroll(function (iScroll) {
		//     iScroll.scrollTo(-(spacialEvents[tempCurrentEvent].raw), 0, 1000);
		// })
		// this.setState({
		//     currentEvent: tempCurrentEvent
		// })
	}

	cycleDate(mode, index) {
		let tempCurrentEvent = this.state.currentEvent;
		if (mode === 0) { //backward
			tempCurrentEvent--;
			if (tempCurrentEvent < 0) {
				tempCurrentEvent = spacialEvents.length - 1;
			}
		}
		else if (mode === 1) { //forward
			tempCurrentEvent++;
			if (tempCurrentEvent > spacialEvents.length - 1) {
				tempCurrentEvent = 0;
			}
		}
		else { //to specific index
			tempCurrentEvent = index;
		}
		this.refDict[0].withIScroll(function (iScroll) {
			iScroll.scrollTo(-(spacialEvents[tempCurrentEvent].raw), 0, 1000);
		})
		this.setState({
			currentEvent: tempCurrentEvent
		})
	}

	renderSpacialEvents() {

		// timeline circle

		let circleRadius = this.props.screen.r16_9.p10 * 0.15

		// let circle = {
		//     width: circleRadius,
		//     height: circleRadius,
		//     WebkitBorderRadius: circleRadius / 2,
		//     MozBorderRadius: circleRadius / 2,
		//     borderRadius: circleRadius / 2,
		//     backgroundColor: '#ffffff',
		//     borderColor: '#FDC700',
		//     border: '1vw',
		//     position: 'absolute',
		//     left: - circleRadius / 2 + this._baseInset
		// }

		if (this.state.spacialEvents.length === 0) {
			return (
				<span />
			)
		}

		const unit = this.props.screen.r9_16.p10
		const infoBlockWidth = unit * 3.35 * .8;
		const insetAmount = unit * 1.55
		const leftInset = -insetAmount - infoBlockWidth;
		const rightInset = insetAmount;
		const imageHeight = unit * 2 * .8;
		const infoHeight = unit * .85 * .8;
		const fullHeight = imageHeight + infoHeight
		const iconWidth = unit * .25;
		// const dateInset = unit * .1;
		// const dateWidth = unit * .25;

		return (
			this.state.spacialEvents.map(function (row, i) {

				// let iref = null;
				// if (_.has(row, 'images[0]')) {
				//     iref = row.images[0];
				// }

				//assume left
				let inset = leftInset
				let dateInset = -insetAmount / 6 - unit * .6
				let horizontalLineInset = -insetAmount + this._baseInset;

				//offset for right scenario
				if (i % 2 === 0) {
					inset = rightInset
					horizontalLineInset = this._baseInset + unit * 1.1
					dateInset = insetAmount / 6
				}
				// console.log("THE ROW", row);
				// console.log("THE GET", _.get(row, 'images[0]', null));
				// let image = "/img/ui/default-user.png";
				// if (_.has(row, 'images[0]')){
				//     image = shared.dpath(this.props.screen.mode, "/" + row.images[0].path, row.images[0].file_name, this.props.screen.webkey)
				// }
				return (
					<div key={i} style={{ position: 'absolute', top: row.offset, zIndex: 0 }}>

						{/* horizontal lines */}
						<div style={{
							position: 'absolute',
							backgroundColor: 'white',
							top: circleRadius / 2,
							left: horizontalLineInset,
							width: unit * .55,
							height: unit * config.line_thickness
						}}>
						</div>
						{/* <span style={{ ...circle }} /> */}
						<div style={{ position: 'absolute', left: this._baseInset - iconWidth / 2 }}>
							<img alt="timlineicon" style={{ width: iconWidth, height: iconWidth }} src={timelineIcon} />
						</div>
						<span style={{ fontSize: unit * .35, position: 'absolute', left: dateInset + this._baseInset, width: unit * 5, top: -unit * .275 }}>
							{row.date}
						</span>
						{/* onClick={() => this.handleEventSelection(row.story)} */}
						<span ref={el => this.timelineRefs[i] = { el: el, data: row.story }} style={{ position: 'absolute', left: (inset) + this._baseInset, top: (-fullHeight / 2) + ((circleRadius / 2)) }}>
							<InfoBlockMiami
								imgsrc={dp(this.props.screen, _.get(row, 'images[0]', null), { path: '/img/ui/', file_name: 'image_default.png' })}
								imageHeight={imageHeight}
								infoHeight={infoHeight}
								width={infoBlockWidth}
								unit={unit * .8}
								text={row.header}
								infoColor={"black"}
								infoBackgroundColor={'white'}
								fontFamily={'opensans-regular'}
								fontSize={unit * 0.15}
							/>
						</span>

					</div>
				)

			}, this)
		)
	}

	handleEventSelection = (story_id) => {
		// let story = _.find(this._stories, {id: Number(story_id)});
		let contentIndex = _.findIndex(this.props.content.stories, { id: Number(story_id) });
		if (contentIndex > -1) {
			this.setState({
				// story: story,
				showStoryModal: true,
				contentIndex: contentIndex
			})
		}

	}

	cycleStory = (direction) => {
		if (direction === "forward") {
			this._eventIndex += 1;
			if (this._eventIndex >= this.props.module.contents.events.length) {
				this._eventIndex = 0;
			}
		}
		else {
			this._eventIndex -= 1;
			if (this._eventIndex < 0) {
				this._eventIndex = this.props.module.contents.events.length - 1;
			}
		}
		if (!this.props.module.contents.events[this._eventIndex].story || isNaN(Number(this.props.module.contents.events[this._eventIndex].story))) {
			this.cycleStory(direction);
		}
		else {
			this.handleEventSelection(this.props.module.contents.events[this._eventIndex].story);
		}
	}

	getBackgroundImage = () => {
		let defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' }

		if (this.props.screensNumber === 2) {
			defaultImg.file_name = 'default_double_screen.jpg';
		}

		try {
			let backgroundReference = this.props.module.contents.custom_fields.background_reference.val;
			let assetsSlideShow = _.find(this.props.content.dm_active, function (o) {
				return o.name.includes("Assets - ");
			});
			let asset = _.indexOf(assetsSlideShow.contents.names, backgroundReference);

			if (!asset || asset === undefined) {
				return dp(this.props.screen, defaultImg);
			}

			return dp(this.props.screen, assetsSlideShow.contents.images[asset]);
		} catch (e) {
			return dp(this.props.screen, defaultImg);
		}
	}

	getIconImage = () => {
		try {
			let iconReference = this.props.module.contents.custom_fields.icon_reference.val;
			let assetsSlideShow = _.find(this.props.content.dm_active, function (o) {
				return o.name.includes("Assets - ");
			});
			let asset = _.indexOf(assetsSlideShow.contents.names, iconReference);

			if (!asset || asset === undefined) {
				return dp(this.props.screen, null);
			}

			return dp(this.props.screen, assetsSlideShow.contents.images[asset]);
		} catch (e) {
			return dp(this.props.screen, null);
		}
	}

	getSubscribeModule = () => {
    const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    const menu = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === Number(rootFolderId) && type === "menu";
		});
		const rootFolder = this.props.content.story_categories.find(folder => folder.id === Number(rootFolderId));
    this._arrowIcon = dp(this.props.screen, _.get(menu, 'contents.images[0]', null), null);
    this._colorPallette = _.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
    const subscribeModule = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === Number(menu.id) && type === "be_the_change";
    });
    this._subscribeModule = subscribeModule;
  }

	beTheChange = () => {
		return (
			<div style={{ marginTop: '7vw', marginBottom: '5vw', display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'flex-start', alignItems: 'stretch', alignContent: 'stretch' }}>
				<div style={{ fontSize: '3.5vw', lineHeight: "107%", textAlign: "left", fontFamily: "opensans-semibold", color: '#ffffff', width: '150vw' }}>
					Be the Change
				<br />
					<span style={{ fontSize: '2.2vw', textAlign: "left", fontFamily: "opensans-regular", color: '#ffffff' }}>
						Help make a difference by becoming a donor.
					</span>
				</div>

				<div style={{ textAlign: 'right', width: '100%' }}>
					<img onClick={() => this.redirect()} alt="Story" src={"/img/miami/general/learnmore_grad_button.png"} style={{ width: '23vw' }} />
				</div>
			</div>
		)
	}

	redirect = () => {
		if (this._subscribeModule !== null && this._subscribeModule !== undefined) {
			this.props.navRoute('/miami/subscribe', this._subscribeModule);
		}
	}

	render() {
		const backgroundImage = this.getBackgroundImage();
		const iconImage = this.getIconImage();
		const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;

		// let iconStyle = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .25' }
		if (!this.state.spacialEvents) {
			return <div />
		}
		// let cycleDateStyle = {
		//     color: 'white',
		//     height: this.props.screen.screenHeight * .06,
		//     fontSize: this.props.screen.screenHeight * .06,
		//     zIndex: 99,
		// }

		// let modalBorderV = .035 * this.props.screen.screenHeight;
		// let modalBorderH = .02 * this.props.screen.r16_9.width;

		let spacialEvents = this.renderSpacialEvents();
		//let quickJumps = this.renderQuickJumps();
		const unit = this.props.screen.r9_16.p10
		// let mult = .8
		let scrollableArea = this.props.screen.r9_16.height * .58;

		return (
			<div style={{ width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundSize: backgroundSize, backgroundImage: "url(" + backgroundImage + ")" }} >
				<div style={{ textAlign: 'center', position: 'absolute' }}>
					<br /><br />
					<img alt="Campaign" src={iconImage} style={{ display: 'block', margin: 'auto', width: '25vw' }} />

					<div style={{ fontFamily: 'opensans-extrabold', fontSize: '6vw' }}>
						{this.props.module.contents.header.toUpperCase()}
					</div>
					<div style={{ fontFamily: 'opensans-regular', fontSize: '3vw', paddingRight:"8.333333333vh", paddingLeft:"8.333333333vh" }}>
						{_.get(this.props.module.contents, 'custom_fields.headline.val', null)}
					</div>
					<div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
						<div style={{ width: '80vw', height: '15vw', borderRadius: '2vw', padding: '5vw' }}>
							<div style={{ color: 'black', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
							</div>
						</div>
					</div>
				</div>

				{/* <div className="topgradblackP25" style={{ width: '100%', height: unit * .25, marginTop:"-1.5625vh" }} /> */}

				
				<div style={{ position: 'absolute', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height }} />
				<div style={{
					position: 'absolute',
					top: unit * 4.8,
					left: 0,
					width: this.props.screen.screenWidth,
					height: scrollableArea,
					touchAction:"none"
				}}>
					<ReactIScroll ref={el => this.refDict[0] = el} iScroll={iScroll}
						onScrollEnd={this.onScrollEnd}
						options={{
							mouseWheel: true,
							scrollbars: false,
							scrollX: false,
							scrollY: true,
							probeType: 2,
							bounce: false,
							momentum: true,
							deceleration: 0.005,
							useTransition: true,
							disableTouch: false,
							disablePointer: false,
							disableMouse: false,
							tap: true
						}}
						onRefresh={this.initializeTimelineRefs}
					>
						
						{/* TIMELINE DIV */}						
						<div style={{ width: this.props.screen.r16_9.width * .6, height: this.state.totalHeight, minHeight: '100%' }}>
							{/* vertical line */}
							<div style={{
								position: 'absolute',
								top: 0,
								backgroundColor: 'white',
								left: this._baseInset,
								width: this.props.screen.sv.p10 * config.line_thickness,
								height: '100%'
							}} />
							<div style={{
								position: 'absolute',
								width: this.props.screen.r16_9.width,
								height: this._titleHorizontalRule.top
							}}>
								{/* <span style={this._titleHorizontalRule} /> */}
							</div>

							{spacialEvents}
						</div>
					</ReactIScroll>
					<div className="bottomgradblackP25" style={{ position: 'absolute', width: '100%', height: unit * .25, bottom: 0 }} />
					<div className="topgradblackP25" style={{ position: 'absolute', width: '100%', height: unit * .25, bottom: '56.6vh' }} />
				</div>
				
				<div style={{ display:"flex", justifyContent:"center" }} >
					<div style={{
						position: 'absolute',
						top: "85vh",
						width: this.props.screen.screenWidth * 0.8,
						height: this.props.screen.r9_16.height * .35,
						fontSize: '4vw',
						fontFamily: 'opensans-bold',
						paddingLeft:"2.6vh",
						paddingRight:"2.6vh"
					}}>
					{this.beTheChange()}
					</div>
				</div>

				<div style={{ position: 'absolute' }}>
					{/* MODAL CODE */}
					<CSSTransitionGroup
						component='div'
						className="containerFade"
						style={{ minHeight: '100%' }}
						transitionName='example'
						transitionEnterTimeout={0}
						transitionLeaveTimeout={0}>
						<div key={this.state.showStoryModal} style={{ position: 'absolute' }}>
							{this.state.showStoryModal ? <StoryMiami backgroundEnabled={true} content={this.props.content} screensNumber={this.props.screensNumber} contentIndex={this.state.contentIndex} screen={this.props.screen} /> : null}
							{this.state.showStoryModal ?
								<BackButtonMiami
									colorPallette={this._colorPallette}
									backButton={this._arrowIcon}
									unit={this.props.screen.r9_16.p10 / this.props.screensNumber}
									width="3.375vh"
									height={miamiConstants.backButtonHeight}
									top="56.46875vh"
									border="0.84375vh"
									clickAction={this.handleBack}
									text={'back'}
									mode={this._mode}>
								</BackButtonMiami>
								: null}
						</div>
					</CSSTransitionGroup >
				</div>
			</div>
		)
	}
}


const mapStateToProps = (state) => {
	return {
		content: state.content,
		screen: state.screen,
	}
}

export default connect(mapStateToProps)(Timeline)


// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/TimelineMiami.js